"use client";

import { ReactNode } from "react";
import ThemeWrapper from "@/context/ThemeWrapper";
import SmoothScroll from "@/components/common/smoothScroll";
import LenisContext from "@/context/LenisContext";
import { TransitionProvider } from "@/context/TransitionContext";
import Preloader from "../preloader/Preloader";

export default function ClientProviders({ children }: { children: ReactNode }) {
	return (
		<TransitionProvider>
			<Preloader />
			<LenisContext>
				<SmoothScroll>
					<ThemeWrapper>{children}</ThemeWrapper>
				</SmoothScroll>
			</LenisContext>
		</TransitionProvider>
	);
}
